module.exports = __webpack_public_path__ + "media/images/new_home/our-mission-81b0f432d3c8e9a7de40d5ff2cc0ddd5.png";